<div class="mainbox" [class.error]="txt.touched && txt.invalid">
    <div [class.error]="txt.touched && txt.invalid"
         [class.gotop]="isshow"
         [class.haserror-gotop]="isshow && txt.touched && txt.invalid"
         (focus)="focusFunction()"
         (click)="focusFunction()"
         (focusout)="focusOutFunction()"
         class="label">
        <span class="txt" [class.hasborder]="required">{{label}}</span>
        <span class="star" *ngIf="required"> * </span>
    </div>
    <div class="inputbox">
        <input (focus)="focusFunction()"
               (focusout)="focusOutFunction()"
               class="textinput"
               [class.hasborder]="isshow "
               [class.error]="txt.touched && txt.invalid"
               type="{{textType}}"
               id="{{name}}"
               [(ngClass)]="class"
               required="{{required}}"
               [(ngModel)]="value"
               name="{{name}}"
               maxlength="{{maxLength}}"
               min="{{min}}"
               max="{{max}}"
               minlength="{{maxLength}}"
               #txt="ngModel"
               disabled="{{disabled}}"
               numbersOnly digits="35" decimals="3"
               autocomplete="{{autocomplete}}"
               pattern="{{pattern}}"
               (ngModelChange)='onChange($event)' />
        <div class="hint unvisible" *ngIf="hint && !txt.touched" [class.visible]="hint && !txt.touched">
            <span>{{hint}}</span>
        </div>
        <div class="error unvisible" *ngIf="txt.touched && txt.invalid" [class.visible]="txt.touched && txt.invalid">
            <span *ngIf="txt.errors.required">
                {{label}} {{'Errors.Required'| translate}}
            </span>
            <span *ngIf="pattern && !txt.errors?.pattern">
                {{label}} {{'Errors.Pattern' | translate}}
            </span>
            <span *ngIf="maxLength && !txt.errors?.minlength">
                {{('Errors.Minlength'| translate ).replace( '[0]' , label).replace( '[1]' , minLength) }}
            </span>
            <span *ngIf="maxLength &&!txt.errors?.maxlength">
                {{('Errors.Maxlength'| translate ).replace( '[0]' , label).replace( '[1]' , minLength) }}
            </span>
            <span *ngIf="min && !txt.errors?.min || max &&  !txt.errors?.max">
                {{('Errors.Length'| translate ).replace( '[0]' , label).replace( '[1]' , min).replace( '[2]' , max) }}
            </span>
        </div>
    </div>
